import React from 'react'
import { Dimensions, View, StyleSheet, Image, Text, ImageSourcePropType, StyleProp, ViewStyle, Platform } from 'react-native'
import Chair from '../../assets/FMBCH-CR-T0-A1-CF-CC-F43.png'
import FisherChair from '../../assets/91-262PCNB-RG-T0-A0-CF-RC-8582.png'
import { GearIcon } from './gear'
import { ProductDisplayImageDesktop } from './product-display-image-desktop'
import Carrot from '../../assets/arrow.png'

const Header = (props: any) => {
  const [height, setHeight] = React.useState(0)

  const header: StyleProp<ViewStyle> = {
    flex: 1,
    overflow: 'hidden',
    minWidth: '50%',
    width: '50%',
    height: height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  return (
    <View style={header}
      onLayout={() => {
        const windowHeight = Dimensions.get('window').height
        setHeight(windowHeight)
      }}
    >
      {
        Platform.OS !== 'web' &&
        <View
          style={styles.gear}
        >
          <GearIcon onPress={props.onSettingsPress} />
        </View>
      }
      {
        props.showRoot === false &&
        <>
          <ProductDisplayImageDesktop 
            defaultSKU={props.sku}
            accentColor={props.accentColor}
            zoomedImgRef={props.zoomedImgRef}
            onZoomHoverBoxOpenChange={props.onZoomHoverBoxOpenChange}
            onZoomHoverBoxPositionChange={props.onZoomHoverBoxPositionChange}
            partner={props.partner}
          />
          <View style={styles.textContainer}>
            <Text style={{fontWeight: 'bold', height: 20}}>{props.customSKU ?? props.sku}</Text>
            <Text style={{fontWeight: 'bold', fontSize: 34, height: 40}}>{props.color}</Text>
          </View>
        </>
      }
      {
        props.showRoot &&
        <>
          <Image style={{minWidth: 200, minHeight: 250, maxHeight: height > 450 ? '60%' : '70%', height: '100%', width: '100%'}} resizeMode={'contain'} source={(props.partner == 'fisher' ? FisherChair : Chair) as ImageSourcePropType} />
          <Text style={{fontWeight: '500', fontSize: 30, color: '#222'}}>Let's build your chair!</Text>
        </>
      }
    </View>
  )
}

export default Header

const styles = StyleSheet.create({
  chair: {
    flex: 1,
    marginBottom: 40,
    height: 400,
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 30,
  },
  logo: {
    width: '40%',
    height: 60,
    margin: 5,
  },
  title: {
    margin: 5,
    fontSize: 34,
    fontWeight: 'bold',
  },
  subTitle: {
    margin: 5,
    fontSize: 36,
  },
  paragraph: {
    margin: 5,
    fontSize: 24,
    fontWeight: '500',
    color: 'gray',
    maxWidth: '90%',
    textAlign: 'center',
  },
  carrot: {
    margin: 10,
    height: 40,
    width: 40,
  },
  gear: {
    position: 'absolute',
    top: 40,
    left: 40,
  },
})
